// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/de75b05d1a3948b765bb.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"ae672fe5faf77ba7b274","143":"90ec81805c4f735f652e","144":"190cfed6e5e8057a51cf"}[chunkId] + ".chunk.js";
};